import {StyledNavbarLink} from "./NavLink.styles";
import React from "react";
import {useHistory} from "react-router-dom";
import PropTypes from 'prop-types';

const NavLink = ({title, color, pathname, navBorder, onClick}) => {

    const history = useHistory();

    const redirect = (link) => {
        if (history.location.pathname === link) {
            window.scrollTo(0, 0);
        }
    };

    return (
        <StyledNavbarLink to={pathname} color={color}
                          title={title} style={navBorder ? {border: '1px solid ' + color} : {}}
                          onClick={onClick ? onClick : () => redirect(pathname)}>
            {title}
        </StyledNavbarLink>
    );
};

NavLink.propTypes = {
    title: PropTypes.string.isRequired,
    linkTo: PropTypes.string,
    color: PropTypes.string,
    pathname: PropTypes.string,
    navBorder: PropTypes.bool
}

export default NavLink;
